<template>
    <v-container>
        <h2 class="sub-titulo text-center">Endereço</h2>
        <br />
        <m-form ref="form_principal">
            <v-row class="data-container">
                <v-col cols="12" class="text-center">
                    <h3>Endereço {{ isPessoaFisica ? 'residencial' : 'comercial' }} *</h3>
                </v-col>
                <v-col cols="12" v-if="exibir_cards_enderecos_newcon" class="endereco-scroll-container">
                    <v-row class="px-0 my-6 d-flex justify-start-but-center-when-small align-self cols">
                        <v-col class="my-6" cols="auto" v-for="(item,index) in enderecosToDisplay" :key="index">
                            <CardEndereco @selecionar="preencherEndereco(item,index,true,'form_principal')" :selecionado="endereco.card_selecionado == index" style="width: 350px;" :index="index" :is-residencial="true" :endereco="item" />
                        </v-col>
                        <v-col class="my-6" cols="auto">
                            <CardNovoItem @click='novoEndereco("form_principal",true)' style="width: 350px;" :selecionado="endereco.card_selecionado == -1">Novo endereço</CardNovoItem>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12">
                    <v-row>
                        <v-btn @click="mostrarMaisEnderecos" v-if="deveExibirBotaoMaisEnderecos" class="button-complete">
                            <hr>
                            <span class="button-span">Ver mais endereços</span>
                            <span class="mdi mdi-plus-circle"></span>
                            <hr>
                        </v-btn>
                    </v-row>
                </v-col>
                <v-col class="col-12 col-md-4 col-lg-3">
                    <m-text-field label="CEP:"
                                  id="FieldCep"
                                  ref="cep"
                                  class="required"
                                  v-model="endereco.cep"
                                  v-mask="'#####-###'"
                                  :disabled="bloquearCamposPorCardsResidencial && !desbloqueioParaConsulta"
                                  outlined
                                  :rules="[$rules.required, $rules.cep]"
                                  @blur="consultaCep(endereco, 'cep', 'form_principal', endereco_bloqueado)"
                                  :name="generateDynamicName('cep_residencial')"
                                  autocomplete="disabled" />
                </v-col>
                <v-col class="col-12 col-md-6 col-lg-7">
                    <m-text-field label="Nome do logradouro:"
                                  id="FieldLogradouro"
                                  class="required"
                                  outlined
                                  v-uppercase
                                  v-input-filter="[$filters.textnumeric]"
                                  :rules="[$rules.required]"
                                  v-model="endereco.endereco"
                                  :disabled="endereco_bloqueado.endereco || bloquearCamposPorCardsResidencial"
                                  maxlength="150"
                                  :name="generateDynamicName('logradouro')"
                                  autocomplete="disabled" />
                </v-col>
                <v-col class="col-12 col-md-2">
                    <m-text-field ref="form_principal_numero"
                                  label="Número:"
                                  id="FieldNumero"
                                  class="required"
                                  outlined
                                  v-uppercase
                                  v-input-filter="[$filters.textnumeric]"
                                  v-model="endereco.numero"
                                  :rules="[$rules.required]"
                                  :disabled="bloquearCamposPorCardsResidencial && !desbloqueioParaConsulta"
                                  maxlength="15"
                                  :name="generateDynamicName('numero')"
                                  autocomplete="disabled" />
                </v-col>
                <v-col class="col-12 col-md-3">
                    <m-text-field label="Complemento:"
                                  id="FieldComplemento"
                                  outlined
                                  v-uppercase
                                  v-input-filter="[$filters.textnumeric]"
                                  v-model="endereco.complemento"
                                  :disabled="bloquearCamposPorCardsResidencial"
                                  maxlength="100"
                                  :name="generateDynamicName('complemento')"
                                  autocomplete="disabled" />
                </v-col>
                <v-col class="col-12 col-md-4">
                    <m-text-field label="Bairro:"
                                  id="FieldBairro"
                                  class="required"
                                  outlined
                                  v-uppercase
                                  v-input-filter="[$filters.textnumeric]"
                                  v-model="endereco.bairro"
                                  :disabled="endereco_bloqueado.bairro || bloquearCamposPorCardsResidencial"
                                  :rules="[$rules.required]"
                                  maxlength="30"
                                  :name="generateDynamicName('bairro')"
                                  autocomplete="disabled" />
                </v-col>
                <v-col class="col-12 col-md-5">
                    <Autocomplete label="Cidade/Estado:"
                                  id="FieldCidade"
                                  class="required"
                                  :rules="[$rules.required]"
                                  :items="cidades"
                                  v-input-filter="[$filters.textnumeric]"
                                  v-model="endereco.id_cidade"
                                  :disabled="endereco_bloqueado.id_cidade || bloquearCamposPorCardsResidencial"
                                  item-text="descricao"
                                  item-value="id_cidade"
                                  placeholder="Selecione uma cidade"
                                  url="/cidade/autocomplete" />
                </v-col>
            </v-row>
        </m-form>
        <m-form ref="form_comercial">
            <v-row class="data-container" v-if="isPessoaFisica">
                <v-col cols="12" class="text-center">
                    <h3>Endereço comercial {{ hasEnderecoComercial ? '*' : '' }}</h3>
                </v-col>
                <v-col cols="12" v-if="exibir_cards_enderecos_newcon" class="endereco-scroll-container">
                    <v-row class="px-0 my-6 d-flex justify-start-but-center-when-small align-self cols">
                        <v-col class="my-6" cols="auto" v-for="(item,index) in enderecosToDisplayComercial" :key="index">
                            <CardEndereco @selecionar="preencherEndereco(item,index,false,'form_comercial')" :selecionado="endereco_comercial.card_selecionado == index" style="width: 350px;" :index="index" :is-residencial="false" :endereco="item" />
                        </v-col>
                        <v-col class="my-6" cols="auto">
                            <CardNovoItem @click='novoEndereco("form_comercial",false)' style="width: 350px;" :selecionado="endereco_comercial.card_selecionado == -1">Novo endereço</CardNovoItem>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12">
                    <v-row class="d-flex justify-center align-center">
                        <v-btn @click="mostrarMaisEnderecos" v-if="deveExibirBotaoMaisEnderecosComercial" class="button-complete">
                            <hr>
                            <span class="button-span">Ver mais endereços</span>
                            <v-icon right>
                                mdi-plus
                            </v-icon>
                            <hr>
                        </v-btn>
                    </v-row>
                </v-col>
                <v-col cols="12" class="text-center error--text py-4" v-if="hasEnderecoComercial && comercial_invalido">
                    Informe os campos obrigatórios do endereço comercial ou apague todos os campos abaixo para
                    prosseguir sem endereço comercial.
                </v-col>
                <v-col class="col-12 col-md-4 col-lg-3">
                    <m-text-field label="CEP:"
                                  id="FieldCepComercial"
                                  ref="cep_comercial"
                                  :class="{required: hasEnderecoComercial}"
                                  v-model="endereco_comercial.cep"
                                  :disabled="bloquearCamposPorCardsComercial && !desbloqueioParaConsulta"
                                  v-mask="'#####-###'"
                                  outlined
                                  :rules="hasEnderecoComercial ? [$rules.required, $rules.cep] : []"
                                  @blur="consultaCep(endereco_comercial, 'cep_comercial', 'form_comercial', endereco_comercial_bloqueado)"
                                  :name="generateDynamicName('cep_comercial')"
                                  autocomplete="disabled" />
                </v-col>
                <v-col class="col-12 col-md-6 col-lg-7">
                    <m-text-field label="Nome do logradouro:"
                                  id="FieldLogradouroComercial"
                                  :class="{required: hasEnderecoComercial}"
                                  outlined
                                  v-uppercase
                                  :disabled="endereco_comercial_bloqueado.endereco || bloquearCamposPorCardsComercial"
                                  v-input-filter="[$filters.textnumeric]"
                                  :rules="hasEnderecoComercial ? [$rules.required] : []"
                                  v-model="endereco_comercial.endereco"
                                  maxlength="150"
                                  :name="generateDynamicName('logradouro')"
                                  autocomplete="disabled" />
                </v-col>
                <v-col class="col-12 col-md-2">
                    <m-text-field ref="form_comercial_numero"
                                  label="Número:"
                                  id="FieldNumeroCOmercial"
                                  :class="{required: hasEnderecoComercial}"
                                  outlined
                                  v-uppercase
                                  :disabled="bloquearCamposPorCardsComercial && !desbloqueioParaConsulta"
                                  v-input-filter="[$filters.textnumeric]"
                                  v-model="endereco_comercial.numero"
                                  :rules="hasEnderecoComercial ? [$rules.required] : []"
                                  maxlength="15"
                                  :name="generateDynamicName('numero_comercial')"
                                  autocomplete="disabled" />
                </v-col>
                <v-col class="col-12 col-md-3">
                    <m-text-field label="Complemento:"
                                  id="FieldComplementoComercial"
                                  outlined
                                  v-uppercase
                                  :disabled="bloquearCamposPorCardsComercial"
                                  v-input-filter="[$filters.textnumeric]"
                                  v-model="endereco_comercial.complemento"
                                  maxlength="100"
                                  :name="generateDynamicName('complemento_comercial')"
                                  autocomplete="disabled" />
                </v-col>
                <v-col class="col-12 col-md-4">
                    <m-text-field label="Bairro:"
                                  id="FieldBairroComercial"
                                  :class="{required: hasEnderecoComercial}"
                                  outlined
                                  :disabled="endereco_comercial_bloqueado.bairro || bloquearCamposPorCardsComercial"
                                  v-uppercase
                                  v-input-filter="[$filters.textnumeric]"
                                  v-model="endereco_comercial.bairro"
                                  :rules="hasEnderecoComercial ? [$rules.required] : []"
                                  maxlength="30"
                                  :name="generateDynamicName('bairro_comercial')"
                                  autocomplete="disabled" />
                </v-col>
                <v-col class="col-12 col-md-5">
                    <Autocomplete label="Cidade/Estado:"
                                  id="FieldCidadeComercial"
                                  :class="{required: hasEnderecoComercial}"
                                  :rules="hasEnderecoComercial ? [$rules.required] : []"
                                  :items="cidades"
                                  :disabled="endereco_comercial_bloqueado.id_cidade || bloquearCamposPorCardsComercial"
                                  v-input-filter="[$filters.textnumeric]"
                                  v-model="endereco_comercial.id_cidade"
                                  item-text="descricao"
                                  item-value="id_cidade"
                                  placeholder="Selecione uma cidade"
                                  url="/cidade/autocomplete" />
                </v-col>
            </v-row>
        </m-form>
        <v-col class="text-center red--text mb-6">
            Campos obrigatórios *
        </v-col>
        <v-row class=" justify-md-space-between">
            <v-btn text id="ButtonVoltar" color="secondary" @click="prevPage">
                Voltar
            </v-btn>
            <v-btn v-if="isPessoaFisica"
                   id="ButtonApagar"
                   color="error"
                   @click="limpar"
                   class="ml-6">
                Apagar endereço comercial
            </v-btn>
            <v-btn color="primary"
                   id="ButtonContinuar"
                   @click="salvar"
                   class="ml-6">
                Continuar
            </v-btn>
        </v-row>
    </v-container>
</template>

<script>
  import { get, isNil, merge, omitBy, orderBy } from 'lodash'
  import { alert, unmask, notification } from '@/plugins/helpers'
  import { TipoEndereco, TipoPessoa } from '@/plugins/constants'
  import CardEndereco from '../../../components/CardEndereco.vue'
  import CardNovoItem from '../../../components/CardNovoItem.vue'
  import verificarDadosUsuarioLogadoMixin from '@/mixins/verificarDadosUsuarioLogadoMixin'
  import { mapState } from 'vuex'
  import { sendAnalyticsEvent } from '@/plugins/googleAnalytics'
  import dynamicNameMixin from '../../../mixins/dynamicNameMixin'
  import { AlertTypes } from '../../../plugins/alerts_types'

  export default {
    components: { CardEndereco, CardNovoItem },
    mixins: [verificarDadosUsuarioLogadoMixin, dynamicNameMixin],
    props: { value: Object },
    data: () => ({
      verificar_se_dados_sao_iguais_usuario_logado: false,
      comercial_invalido: false,
      bloquear_campos_pelos_cards_residencial: true,
      bloquear_campos_pelos_cards_comercial: true,
      acionou_novo_endereco_residencial: false,
      acionou_novo_endereco_comercial: false,
      enderecos_newcon_residencial: [],
      enderecos_newcon_comercial: [],
      desbloqueioParaConsulta: false,
      preenche_estepe: false,
      preenche_estepe_comercial: false,
      pedido: {
        cliente: {
          id_cliente: null,
          pessoa: TipoPessoa.Fisica
        }
      },
      endereco: {
        id_cliente: '',
        cep: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        id_cidade: '',
        tipo_endereco: TipoEndereco.Residencial,
        card_selecionado: -2,
        bloqueado: false
      },
      endereco_comercial: {
        id_endereco: '',
        id_cliente: '',
        cep: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        id_cidade: '',
        tipo_endereco: TipoEndereco.Comercial,
        card_selecionado: -2,
        bloqueado: false
      },
      endereco_estepe: {
        id_cliente: '',
        cep: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        id_cidade: '',
        tipo_endereco: TipoEndereco.Residencial,
        card_selecionado: null,
        bloqueado: false
      },
      endereco_comercial_estepe: {
        id_endereco: '',
        id_cliente: '',
        cep: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        id_cidade: '',
        tipo_endereco: TipoEndereco.Comercial,
        card_selecionado: null,
        bloqueado: false
      },
      endereco_bloqueado: {
        id_cidade: false
      },
      endereco_comercial_bloqueado: {
        id_cidade: false
      },
      cidades: [],
      linhasExibidas: 2,
      enderecosPorLinha: 2
    }),
    computed: {
      haveDataLoggedUserAndCpfCnpjIsNotEqual () {
        return this.verificar_se_dados_sao_iguais_usuario_logado && this.$session.get('dados_usuario_logado') !== {}
      },
      exibir_cards_enderecos_newcon () {
        return this.enderecos_newcon_residencial.length > 0 || this.enderecos_newcon_comercial.length > 0
      },
      bloquearCamposPorCardsResidencial () {
        return (this.bloquear_campos_pelos_cards_residencial && this.exibir_cards_enderecos_newcon && !(this.endereco.card_selecionado === -1))
      },
      bloquearCamposPorCardsComercial () {
        return (this.bloquear_campos_pelos_cards_comercial && this.exibir_cards_enderecos_newcon && !(this.endereco_comercial.card_selecionado === -1))
      },
      isPessoaFisica () {
        return this.pedido.cliente && this.pedido.cliente.pessoa && this.pedido.cliente.pessoa === TipoPessoa.Fisica
      },
      hasEnderecoComercial () {
        return !!this.endereco_comercial.bairro || !!this.endereco_comercial.cep || !!this.endereco_comercial.complemento || !!this.endereco_comercial.endereco || !!this.endereco_comercial.id_cidade || !!this.endereco_comercial.numero || this.endereco_comercial.card_selecionado === -1
      },
      enderecosToDisplay () {
        return this.enderecos_newcon_residencial.slice(0, this.linhasExibidas * this.enderecosPorLinha)
      },
      enderecosToDisplayComercial () {
        return this.enderecos_newcon_comercial.slice(0, this.linhasExibidas * this.enderecosPorLinha)
      },
      deveExibirBotaoMaisEnderecos () {
        return this.enderecos_newcon_residencial.length > this.linhasExibidas * this.enderecosPorLinha
      },
      deveExibirBotaoMaisEnderecosComercial () {
        return this.enderecos_newcon_comercial.length > this.linhasExibidas * this.enderecosPorLinha
      },
      ...mapState([ 'id_usuario', 'jornada_venda' ])
    },
    async mounted () {
      this.pedido.cliente = Object.assign({}, this.pedido.cliente, this.value.cliente)

      const dado_usuario_a_verificar = this.isPessoaFisica ? this.pedido.cliente.cpf : this.pedido.cliente.cnpj
      this.verificar_se_dados_sao_iguais_usuario_logado = !(await this.verificaSeCpfCnpjEIgual(dado_usuario_a_verificar, this.id_usuario))

      // Verifica se a pessoa existe no newcon
      if (this.pedido.cliente.id_pessoa_erp != null && this.pedido.cliente.id_pessoa_erp > 0) {
        try {
          await this.buscaEnderecosNewcon(this.pedido.cliente.id_pessoa_erp)
        } catch {};
      } else if (this.pedido.cliente.id_cliente != null && this.pedido.cliente.id_cliente > 0) {
        this.buscaEnderecosBaseIntermediaria(this.pedido.cliente.id_cliente)
      }

      this.pedido = merge({}, this.pedido, this.value)
      if (this.pedido.cliente && this.pedido.cliente.enderecos) {
        this.endereco = merge({}, this.endereco, omitBy(this.pedido.cliente.enderecos[0], isNil))
        this.endereco.card_selecionado = this.$session.get('index_endereco_residencial') === 0 ? this.$session.get('index_endereco_residencial') : this.$session.get('index_endereco_residencial') || null

        if (this.pedido.cliente.enderecos.length > 1) {
          this.endereco_comercial = merge({}, this.endereco, omitBy(this.pedido.cliente.enderecos[1], isNil))

          if (this.endereco_comercial.bloqueado) {
            this.bloquearCampos(this.endereco_comercial_bloqueado, this.endereco_comercial)
          }
          this.endereco_comercial.card_selecionado = this.$session.get('index_endereco_comercial') === 0 ? this.$session.get('index_endereco_comercial') : this.$session.get('index_endereco_comercial') || null
        } else {
          this.endereco_comercial.card_selecionado = null
        }
        if (this.endereco.bloqueado) {
          this.bloquearCampos(this.endereco_bloqueado, this.endereco)
        }
      } else {
        this.endereco.card_selecionado = null
      }
      const id_cidade_residencial = get(this.endereco, 'id_cidade', null)
      const id_cidade_comercial = get(this.endereco_comercial, 'id_cidade', null)
      if (id_cidade_residencial) {
        this.getCidades(id_cidade_residencial, 'form_principal')
      }
      if (id_cidade_comercial) {
        this.getCidades(id_cidade_comercial, 'form_comercial')
      }
      this.endereco.tipo_endereco = this.isPessoaFisica ? TipoEndereco.Residencial : TipoEndereco.Comercial

      if (this.pedido.cliente.tribanco && this.pedido.cliente.pessoa === TipoPessoa.Juridica && !!this.endereco.cep) {
        this.$refs.cep.focus()
        this.$refs.cep.blur()
      }
    },
    methods: {
      novoEndereco (form_name, isResidencial) {
        this.preenche_estepe = true
        this.preenche_estepe_comercial = true
        if (!this.acionou_novo_endereco_residencial && isResidencial) {
          this.$refs[form_name].reset()
          this.acionou_novo_endereco_residencial = true
        } else if (isResidencial) {
          this.colocarEnderecoDaBaseOuDoFormularioNoFormulario(true, this.endereco_estepe, form_name)
        }
        if (!this.acionou_novo_endereco_comercial && !isResidencial) {
          this.$refs[form_name].reset()
          this.acionou_novo_endereco_comercial = true
        } else if (!isResidencial) {
          this.colocarEnderecoDaBaseOuDoFormularioNoFormulario(false, this.endereco_comercial_estepe, form_name)
        }
        if (isResidencial) {
          this.bloquear_campos_pelos_cards_residencial = false
          this.$session.set('index_endereco_residencial', -1)
          this.endereco.card_selecionado = -1
        } else {
          this.bloquear_campos_pelos_cards_comercial = false
          this.$session.set('index_endereco_comercial', -1)
          this.endereco_comercial.card_selecionado = -1
        }
      },
      preencherEndereco (endereco, index, isResidencial, form_name) {
        if (this.preenche_estepe && isResidencial) {
          this.endereco_estepe.cep = this.endereco.cep
          this.endereco_estepe.card_selecionado = this.endereco.card_selecionado
          this.endereco_estepe.endereco = this.endereco.endereco
          this.endereco_estepe.numero = this.endereco.numero
          this.endereco_estepe.complemento = this.endereco.complemento
          this.endereco_estepe.bairro = this.endereco.bairro
          this.endereco_estepe.id_cidade = this.endereco.id_cidade
        }
        if (this.preenche_estepe_comercial && !isResidencial) {
          this.endereco_comercial_estepe.cep = this.endereco_comercial.cep
          this.endereco_comercial_estepe.card_selecionado = this.endereco_comercial.card_selecionado
          this.endereco_comercial_estepe.endereco = this.endereco_comercial.endereco
          this.endereco_comercial_estepe.numero = this.endereco_comercial.numero
          this.endereco_comercial_estepe.complemento = this.endereco_comercial.complemento
          this.endereco_comercial_estepe.bairro = this.endereco_comercial.bairro
          this.endereco_comercial_estepe.id_cidade = this.endereco_comercial.id_cidade
        }
        this.preenche_estepe = false
        this.preenche_estepe_comercial = false

        if (isResidencial) {
          this.$session.set('index_endereco_residencial', index)
          this.endereco.card_selecionado = index
        } else {
          this.$session.set('index_endereco_comercial', index)
          this.endereco_comercial.card_selecionado = index
        }
        this.bloquear_campos_pelos_cards_residencial = true
        this.bloquear_campos_pelos_cards_comercial = true
        this.colocarEnderecoNewconNoFormulario(isResidencial, endereco, form_name)
      },
      async colocarEnderecoNewconNoFormulario (isResidencial, endereco, form_name) {
        let campo_cep = isResidencial ? 'cep' : 'cep_comercial'
        let endereco_para_setar = isResidencial ? this.endereco : this.endereco_comercial
        let final_cep = endereco.CEP.substring(0, endereco.CEP.length - 3)
        let comeco_cep = endereco.CEP.substring(endereco.CEP.length - 3, endereco.CEP.length)
        endereco_para_setar.cep = final_cep + '-' + comeco_cep
        endereco_para_setar.endereco = endereco.Endereco
        endereco_para_setar.numero = endereco.NO_Endereco
        endereco_para_setar.bairro = endereco.Bairro
        endereco_para_setar.id_cidade = endereco.ID_Cidade
        endereco_para_setar.complemento = endereco.Complemento
        this.desbloqueioParaConsulta = true
        this.$refs[campo_cep].focus()
        this.setarCidade(endereco_para_setar.id_cidade, form_name)
        this.desbloqueioParaConsulta = false
      },
      async colocarEnderecoDaBaseOuDoFormularioNoFormulario (isResidencial, endereco, form_name) {
        let campo_cep = isResidencial ? 'cep' : 'cep_comercial'
        let endereco_para_setar = isResidencial ? this.endereco : this.endereco_comercial
        endereco_para_setar.cep = endereco.cep
        endereco_para_setar.endereco = endereco.endereco
        endereco_para_setar.card_selecionado = endereco.card_selecionado
        endereco_para_setar.numero = endereco.numero
        endereco_para_setar.bairro = endereco.bairro
        endereco_para_setar.id_cidade = endereco.id_cidade
        endereco_para_setar.complemento = endereco.complemento !== null ? endereco.complemento : ''
        this.desbloqueioParaConsulta = true
        if (campo_cep !== '') { this.$refs[campo_cep].focus() }
        if (endereco_para_setar.id_cidade !== '' && endereco_para_setar.id_cidade !== null) { this.setarCidade(endereco_para_setar.id_cidade, form_name) }

        isResidencial ? this.endereco = endereco_para_setar : this.endereco_comercial = endereco_para_setar

        this.desbloqueioParaConsulta = false
      },
      prevPage () {
        this.$emit('prevPage')
      },
      limpar () {
        alert({
          text: 'Tem certeza de que deseja apagar o endereço comercial?',
          buttons: {
            'Cancelar': () => true,
            'Confirmar': () => {
              this.apagarEnderecoComercial()
              this.endereco_comercial.card_selecionado = null
              this.$session.set('index_endereco_comercial', null)
            }
          }
        })
      },
      async buscaEnderecosNewcon (id_cliente_erp) {
        await this.$http.get(`/clientes/endereco_newcon/${id_cliente_erp}`).then((response) => {
          let enderecos_comerciais = []
          let enderecos_residenciais = []
          if (this.isPessoaFisica) {
            response.data.forEach((item) => {
              if (item.ID_Tipo_Endereco !== 2) {
                enderecos_residenciais.push(item)
              } else {
                enderecos_comerciais.push(item)
              }
            })
          } else {
            response.data.forEach((item) => {
              if (item.ID_Tipo_Endereco === 2) {
                enderecos_residenciais.push(item)
              }
            })
          }

          this.enderecos_newcon_residencial = orderBy(enderecos_residenciais, ['NO_Sequencia'], ['asc'])
          this.enderecos_newcon_comercial = orderBy(enderecos_comerciais, ['NO_Sequencia'], ['asc'])
        })
      },
      async buscaEnderecosBaseIntermediaria (id_cliente_base) {
        await this.$http.get(`/clientes/enderecos/${id_cliente_base}`).then((response) => {
          const endereco_comercial_base = response.data.endereco_comercial
          const endereco_residencial_base = response.data.endereco_residencial
          if (this.isPessoaFisica) {
            if (endereco_residencial_base !== '') {
              this.colocarEnderecoDaBaseOuDoFormularioNoFormulario(true, endereco_residencial_base, 'form_principal')
            }
            if (endereco_comercial_base !== '') {
              this.colocarEnderecoDaBaseOuDoFormularioNoFormulario(false, endereco_comercial_base, 'form_comercial')
            }
          } else {
            if (endereco_comercial_base !== '') {
              this.colocarEnderecoDaBaseOuDoFormularioNoFormulario(true, endereco_comercial_base, 'form_principal')
            }
          }
        })
      },
      async apagarEnderecoComercial () {
        try {
          this.$refs.form_comercial.reset()

          if (typeof (this.endereco_comercial.id_endereco) === 'number') {
            await this.$http.delete(`/endereco/${this.endereco_comercial.id_endereco}`)
          }
        } catch (e) {
          notification('error', e, 'Não foi possível apagar o endereço, tente novamente mais tarde!')
        }
      },
      salvar () {
        const { form_principal, form_comercial } = this.$refs

        this.comercial_invalido = this.hasEnderecoComercial && !form_comercial.validate()

        if (form_principal.validate() && !this.comercial_invalido) {
          let bloquearUsuario = false

          const id_cidade_residencial = get(this.endereco, 'id_cidade', null)
          const id_cidade_comercial = get(this.endereco_comercial, 'id_cidade', null)
          if (id_cidade_residencial) {
            this.getCidades(id_cidade_residencial, 'form_principal')
          }
          if (id_cidade_comercial) {
            this.getCidades(id_cidade_comercial, 'form_comercial')
          }

          if (this.haveDataLoggedUserAndCpfCnpjIsNotEqual) {
            // CPF CNPJ Diferente, verificar dados
            try {
              const cliente = this.pedido.cliente
              const id_pedido = this.pedido.id_pedido ? this.pedido.id_pedido : null
              // eslint-disable-next-line no-constant-condition
              const enderecos = [this.endereco] ? [this.endereco] : null
              if (this.hasEnderecoComercial) {
                enderecos.push(this.endereco_comercial)
              }
              if (this.verifyIfSomeInputIsEqualUserLoggedData(id_pedido, cliente.email, cliente.pessoa === 'fisica' ? cliente.telefone_residencial : cliente.telefone_comercial, cliente.telefone_celular, enderecos)) {
                bloquearUsuario = true
              }
            } catch (e) {
              // Não exibir erro em tela
            }
          } else {
            // CPF CNPJ Igual,Não verificar dados
          }
          if (bloquearUsuario) {
            return null
          }
          this.comercial_invalido = false
          this.endereco = merge({}, this.pedido.cliente.endereco, this.endereco)
          this.pedido.cliente.enderecos = [this.endereco]

          if (this.hasEnderecoComercial) { this.pedido.cliente.enderecos.push(this.endereco_comercial) }
          this.sendAnalytics()
          if (!(this.exibir_cards_enderecos_newcon)) {
            this.salvarNoBanco()
          } else {
            this.salvarNoNewconEBanco()
          }
        }
      },
      sendAnalytics () {
        const extra_params = !this.isPessoaFisica ? {}
          : {
            cidade_residencial: this.cidades.find(cidade => cidade.id_cidade === this.endereco.id_cidade)?.nome,
            estado_residencial: this.cidades.find(cidade => cidade.id_cidade === this.endereco.id_cidade)?.uf,
            cep_residencial: this.endereco.cep
          }

        sendAnalyticsEvent(this.$gtag, 'cadastro_endereco', {
          ...extra_params,
          cidade_comercial: !this.isPessoaFisica ? this.cidades.find(cidade => cidade.id_cidade === this.endereco.id_cidade)?.nome : this.cidades.find(cidade => cidade.id_cidade === this.endereco_comercial.id_cidade)?.nome,
          estado_comercial: !this.isPessoaFisica ? this.cidades.find(cidade => cidade.id_cidade === this.endereco.id_cidade)?.uf : this.cidades.find(cidade => cidade.id_cidade === this.endereco_comercial.id_cidade)?.uf,
          cep_comercial: !this.isPessoaFisica ? this.endereco.cep : this.endereco_comercial.cep,
          source_menu: this.jornada_venda
        })
      },
      salvarNoNewconEBanco () {
        if (this.isPessoaFisica) {
          if (this.endereco.card_selecionado === -1 && this.endereco_comercial.card_selecionado === -1) {
            this.dialogEnderecos([this.endereco, this.endereco_comercial])
          } else if (this.endereco.card_selecionado === -1) {
            this.dialogEnderecos([this.endereco])
          } else if (this.endereco_comercial.card_selecionado === -1) {
            this.dialogEnderecos([this.endereco_comercial])
          } else {
            this.salvarNoBanco()
          }
        } else {
          if (this.endereco.card_selecionado === -1) {
            this.dialogEnderecos([this.endereco])
          } else {
            this.salvarNoBanco()
          }
        }
      },
      salvarNoBanco () {
        this.$http.post(`/enderecos/salvar/${this.pedido.cliente.id_cliente}`, this.pedido.cliente.enderecos)
          .then((res) => {
            this.pedido.cliente.enderecos = res.data
            this.$emit('input', this.pedido)
            this.$emit('nextPage')
          })
          .catch(() => notification('warning', 'Caro parceiro, foi encontrado um erro ao consultar as cidades, sugerimos tentar novamente e caso o erro persistir entre em contato com a Área de Suporte.'))
      },
      dialogEnderecos (enderecos) {
        alert({
          text: `Você informou um ou mais endereços que serão inseridos no cadastro do cliente e utilizados nesta venda. \nDeseja continuar?`,
          buttons: {
            'Cancelar': () => true,
            'Confirmar': async () => {
              await this.actionConfirmarEnderecoNewcon(enderecos)
              this.salvarNoBanco()
            }
          }
        })
      },
      async actionConfirmarEnderecoNewcon (enderecos) {
        enderecos.forEach(async endereco => {
          if (endereco.tipo_endereco === TipoEndereco.Residencial) {
            try {
              await this.salvarEnderecoNewcon(this.endereco)
              this.$session.set('index_endereco_residencial', this.enderecos_newcon_residencial.length)
            } catch (e) {
              this.$session.set('index_endereco_residencial', null)
            }
          } else {
            try {
              if (this.isPessoaFisica) {
                await this.salvarEnderecoNewcon(this.endereco_comercial)
                this.$session.set('index_endereco_comercial', this.enderecos_newcon_comercial.length)
              } else {
                await this.salvarEnderecoNewcon(this.endereco)
                this.$session.set('index_endereco_residencial', this.enderecos_newcon_residencial.length)
              }
            } catch (e) {
              if (this.isPessoaFisica) {
                this.$session.set('index_endereco_comercial', null)
              } else {
                this.$session.set('index_endereco', null)
              }
            }
          }
        })
      },
      async salvarEnderecoNewcon (endereco) {
        await this.$http.post(`/enderecos/salvar_newcon/${this.pedido.cliente.id_pessoa_erp}`, endereco)
      },
      consultaCep (endereco, ref_name, form_name, campos) {
        if (!endereco.cep || !this.$refs[ref_name].validate()) {
          this.desbloquearCampos(campos, endereco)
          return
        }

        // if (endereco.endereco && endereco.bairro && endereco.id_cidade) {
        //   return
        // }

        this.$refs[form_name].resetValidation()

        return this.$http.get('/cep', { params: { CEP: unmask(endereco.cep) } })
          .then(result => {
            if (result.data) {
              if (result.data.cep_nao_encontrado) {
                notification(AlertTypes.ERROR, result.data.message || 'O CEP digitado não foi encontrado. Caso o erro persista, entre em contato com a Área de Suporte.')
                this.desbloquearCampos(campos, endereco)
                return
              }

              endereco.endereco = (result.data['Endereco'] || '').trim()
              endereco.bairro = (result.data['Bairro'] || '').trim()
              if (result.data['ID_Cidade']) {
                endereco.id_cidade = (result.data['ID_Cidade'] || endereco.id_cidade)
                this.getCidades(endereco.id_cidade, form_name).then(() => {
                  this.$refs[`${form_name}_numero`].focus()
                  this.$refs[form_name].resetValidation()
                })
              } else {
                endereco.id_cidade = 0
                delete campos['id_cidade']
                this.$refs[form_name].resetValidation()
              }
              this.bloquearCampos(campos, endereco)
            } else {
              notification(AlertTypes.ERROR, 'Não foi possível buscar o cep informado')
            }
          })
      },
      async setarCidade (id_cidade, form_name) {
        if (id_cidade) {
          await this.getCidades(id_cidade, form_name).then(() => {
            this.$refs[`${form_name}_numero`].focus()
            this.$refs[form_name].resetValidation()
          })
        } else {
          this.endereco.id_cidade = 0
          this.$refs[form_name].resetValidation()
        }
      },
      bloquearCampos (campos, model) {
        Object.keys(campos).forEach(campo => {
          campos[campo] = !!model[campo]
        })
        model.bloqueado = true
      },
      desbloquearCampos (campos, model) {
        Object.keys(campos).forEach(campo => {
          campos[campo] = false
          model[campo] = ''
        })
        model.bloqueado = false
      },
      async getCidades (id_cidade, form_name) {
        try {
          const result = await this.$http.get(`cidade/${id_cidade}`)
          if (!result.data) {
            notification('error', 'Não foi possível buscar a cidade do cep informado!')
            return
          }
          this.cidades.push(result.data)
        } catch (e) {
          const isResidencial = (form_name === 'form_principal')
          this.resetaCidade(isResidencial)
          notification('error', 'Não foi possível buscar a cidade do cep informado!')
        }
      },
      resetaCidade (isResidencial) {
        if (isResidencial) {
          this.endereco.id_cidade = 0
          this.endereco_bloqueado.id_cidade = 0
        } else {
          this.endereco_comercial_bloqueado.id_cidade = 0
          this.endereco_comercial.id_cidade = 0
        }
      },
      mostrarMaisEnderecos () {
        this.linhasExibidas += 2
      }
    }
  }
</script>
<style scoped lang="scss">
    h3 {
        font-size: 1.5rem;
        color: var(--primary);
        margin-bottom: 15px;
    }
    .justify-start-but-center-when-small{
      justify-content: flex-start;
      @media (max-width: 1500px) {
        justify-content: center;
      }
    }

    .data-container {
        margin-bottom: 30px;
        padding-bottom: 10px;
        border-bottom: 1px solid #E2E2E2;
    }

    .data-container:last-child {
        margin-bottom: 0;
        border: none;
    }

    .button-complete {
      background-color: #fff;
      color: var(--primary);
      width: 100%;
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 40px;
    }

    .button-span {
        width: 200px;
        padding-right: 1px;
        display: inline-block;
        position: relative;
        white-space: nowrap;
    }

    hr {
        width: 100%;
    }

    .endereco-scroll-container {
        max-height: 500px;
        overflow-y: auto;
        margin-bottom: 40px;
        padding-bottom: 20px;
    }

</style>
